export const isNullOrEmpty = (value) => {
  if (value) {
    return parseFloat(value) === 0;
  } else return true
};